import { Button, Chip, Input, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiOutlinedInput-input": {
      color: "green",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "purple",
    },
    "& .MuiInputLabel-outlined": {
      color: "green",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "red",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "purple",
    },
  },
});

const AcademicTestPage = () => {
  const classes = useStyles();
  const [clicked, setClicked] = useState(false);
  const [text, setText] = useState(null);
  const [color1, setColor] = useState(false);
  const [gre, setGre] = useState(false);
  const [gmat, setGmat] = useState(false);
  const [none, setnone] = useState(false);

  const [errgreverbal, seterrgreverbal] = useState(false);
  const [errgrequant, seterrgrequant] = useState(false);
  const [errgmat, seterrgmat] = useState(false);
   const [clickedColor , setClickedColor] = useState(false)

  const navigate = useNavigate();

  const handleClickGre = () => {
    setGre(true);
    setGmat(false);

    setnone(false);
    seterrgreverbal(false);
  };

  const handleClickGmat = () => {
    setGre(false);
    setGmat(true);
    setnone(false);
    seterrgreverbal(false);
  };

  const handleClicknone = () => {
    setGre(false);
    setGmat(false);
    setnone(true);
    seterrgreverbal(true);
  };

  const handlegreverbalscore = (e) => {
    if (e.target.value >= 130 && e.target.value <= 170) {
      seterrgreverbal(true);
    } else {
      seterrgreverbal("GRE Verbal score must be in between 130-170");
    }
  };

  const handlegrequantscore = (e) => {
    if (e.target.value >= 130 && e.target.value <= 170) {
      seterrgrequant(true);
    } else {
      seterrgrequant("GRE Quant score must be in between 130-170");
    }
  };

  const handlegmatscore = (e) => {
    if (e.target.value >= 540 && e.target.value <= 800) {
      seterrgmat(true);
    } else {
      seterrgmat("GMAT score must be in between 540-800");
    }
  };

  const handleClick = (e) => {
    if (clickedColor == false) {
      setColor(true);
      setClickedColor(true);
    } else {
      setColor(false);
      setClickedColor(false);
    }

    setClicked(true);
    setText(e.target.innerHTML);
    console.log(e.target.innerHTML);
    console.info("You clicked the Chip.");
  };

  const handleClickButton = () => {
    navigate("/profile");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <div>
                  <Typography
                    color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                  >
                    Which academic test have you taken OR are planning to take?
                  </Typography>
                </div>
                <div className="p-20 flex items-center justify-center ">
                  <Stack
                    direction="row"
                    spacing={1}
                    className="crad equalMargin"
                  >
                    <Chip
                      className="p-20 rounded-full font-bold border-3 text-14"
                      sx={{ fontSize: "18px", color: "white" }}
                      size="medium"
                      label="GRE"
                      style={{
                        backgroundColor: gre ? "#603aa2" : "#c59bdb",
                        size: "100px",
                      }}
                      variant={gre ? "filled" : "outlined"}
                      onClick={(e) => handleClickGre(e)}
                    />
                    <Chip
                      label="GMAT"
                      className="p-20 mx-10 rounded-full font-bold border-3 text-14"
                      sx={{ fontSize: "18px", color: "white" }}
                      size="medium"
                      style={{ backgroundColor: gmat ? "#603aa2" : "#c59bdb" }}
                      variant={gmat ? "filled" : "outlined"}
                      onClick={(e) => handleClickGmat(e)}
                    />

                    <Chip
                      label="Not Planning To Take Any"
                      className="p-20 rounded-full font-bold border-3 text-14"
                      sx={{ fontSize: "18px", color: "white" }}
                      size="medium"
                      style={{ backgroundColor: none ? "#603aa2" : "#c59bdb" }}
                      variant={none ? "filled" : "outlined"}
                      onClick={(e) => handleClicknone(e)}
                    />
                  </Stack>
                </div>

                {gre && (
                  <>
                    <div className="flex space-x-10 justify-center">
                      <div className="flex flex-col justify-center">
                        <Typography
                          color="secondary"
                          fontSize={23}
                          align="center"
                          className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                        >
                          Enter your verbal score
                        </Typography>
                        <center>
                          <Input
                            type="number"
                            onChange={(e) => handlegreverbalscore(e)}
                            style={{
                              width: "200px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#5D3FD3",
                            }}
                          ></Input>
                        </center>
                        <Typography
                          color="secondary"
                          fontSize={18}
                          align="center"
                          className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                        >
                          {errgreverbal}
                        </Typography>
                      </div>

                      <div className="flex flex-col justify-center">
                        <Typography
                          color="secondary"
                          fontSize={23}
                          align="center"
                          className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                        >
                          Enter your Quant score
                        </Typography>

                        <center>
                          <Input
                            type="number"
                            onChange={(e) => handlegrequantscore(e)}
                            style={{
                              width: "200px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#5D3FD3",
                            }}
                          ></Input>
                        </center>

                        <Typography
                          color="secondary"
                          fontSize={18}
                          align="center"
                          className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                        >
                          {errgrequant}
                        </Typography>
                      </div>
                    </div>
                  </>
                )}

                {gmat && (
                  <>
                    <div className="flex flex-col justify-center">
                      <Typography color="secondary"
                    fontSize={23}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        Enter your score
                      </Typography>
                      <center>
                        <Input
                          type="number"
                          onChange={(e) => handlegmatscore(e)}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                        ></Input>
                      </center>
                      <Typography color="secondary"
                    fontSize={18}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        {errgmat}
                      </Typography>
                    </div>
                  </>
                )}

                {none && (
                  <>
                    <div className="flex flex-col justify-center invisible">
                      <Typography color="secondary"
                    fontSize={23}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        Enter your score
                      </Typography>
                      <center>
                        <Input
                          type="number"
                          onChange={(e) => handlegmatscore(e)}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        ></Input>
                      </center>
                      <Typography color="secondary"
                    fontSize={18}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        {errgmat}
                      </Typography>
                    </div>
                  </>
                )}

                <div className="d-flex mt-5 items-center  justify-center crad equalMargin">
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleClickButton}
                    style={{ backgroundColor: "#603aa2" }}
                    disabled={
                      errgrequant == true ||
                      errgreverbal == true ||
                      errgmat == true
                        ? false
                        : true
                    }
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default AcademicTestPage;
